import axios from 'axios'
import { isCookieEnabled, getCookie } from 'tiny-cookie'

const getRequest = function (domain, url, data, resolve, reject, timeout = 10000) {
  const config = {
    baseURL: domain,
    timeout: timeout,
    headers: {
      'Content-Type': 'application/json'
    }
  }
  const token = isCookieEnabled() ? getCookie('token') : ''
  if (token) {
    config.headers['Authorization'] = `JWT ${token}`
  }
  const instance = axios.create(config)
  instance
    .get(url, data)
    .then(res => {
      resolve(res)
    })
    .catch(error => {
      reject(error)
    })
}

const postRequest = function (domain, url, data, resolve, reject, timeout = 10000) {
  const config = {
    baseURL: domain,
    timeout: timeout,
    headers: {
      'Content-Type': 'application/json'
    }
  }
  const token = isCookieEnabled() ? getCookie('token') : ''
  if (token) {
    config.headers['Authorization'] = `JWT ${token}`
  }
  const instance = axios.create(config)
  instance
    .post(url, data)
    .then(res => {
      resolve(res)
    })
    .catch(error => {
      reject(error)
    })
}

const deleteRequest = function (domain, url, data, resolve, reject, timeout = 10000) {
  const config = {
    baseURL: domain,
    timeout: timeout,
    headers: {
      'Content-Type': 'application/json'
    }
  }
  const token = isCookieEnabled() ? getCookie('token') : ''
  if (token) {
    config.headers['Authorization'] = `JWT ${token}`
  }
  const instance = axios.create(config)
  instance
    .delete(url, data)
    .then(res => {
      resolve(res)
    })
    .catch(error => {
      reject(error)
    })
}

const putRequest = function (domain, url, data, resolve, reject, timeout = 10000) {
  const config = {
    baseURL: domain,
    timeout: timeout,
    headers: {
      'Content-Type': 'application/json'
    }
  }
  const token = isCookieEnabled() ? getCookie('token') : ''
  if (token) {
    config.headers['Authorization'] = `JWT ${token}`
  }
  const instance = axios.create(config)
  instance
    .put(url, data)
    .then(res => {
      resolve(res)
    })
    .catch(error => {
      reject(error)
    })
}

const getRequestWithoutAuth = function (domain, url, data, resolve, reject, timeout = 10000) {
  const config = {
    baseURL: domain,
    timeout: timeout,
    headers: {
      'Content-Type': 'application/json'
    }
  }
  const instance = axios.create(config)
  instance
    .get(url, data)
    .then(res => {
      resolve(res)
    })
    .catch(error => {
      reject(error)
    })
}

export default {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest,
  getRequestWithoutAuth
}
